import { Lock, Tuning } from "@solar-icons/react/ssr";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { getReadOnly } from "./bidStore";

const TopSheetButton = ({ variant, onOpen }) => {
    const readOnly = getReadOnly();
    const handleOpenTopSheetConfig = () => {
        onOpen && onOpen();
    };
    const Icon = readOnly ? Lock : Tuning;
    return (
        <>
            <Button
                size={variant == "endIcon" ? "small" : "medium"}
                variant="contained"
                startIcon={variant == "startIcon" && <Icon />}
                endIcon={variant == "endIcon" && <Icon />}
                onClick={handleOpenTopSheetConfig}
                color="secondary"
            >
                Top Sheet
            </Button>
        </>
    );
};

// attempt to have IDE autocomplete string options
TopSheetButton.propTypes = {
    variant: PropTypes.oneOf(["startIcon", "endIcon"]).isRequired,
};

export default TopSheetButton;
